import { Fragment } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Outlet } from '@usas/ui-web/wrappers/ReactRouterDom';

import useNavRoutes from '@usas/ui-web/state/security/UseNavRoutes';

import LoadingModal from '@usas/ui-web/components/dialogs/LoadingModal';
import PageNotFound from '@usas/ui-web/components/PageNotFound';
import UnexpectedError from '@usas/ui-web/components/UnexpectedError';
import SecuredRouteElement from '@usas/ui-web/components/security/SecuredRouteElement';
import ErrorBoundary from '@usas/ui-web/components/errors/ErrorBoundary';
import ErrorBoundaryFallback from '@usas/ui-web/components/errors/ErrorBoundaryFallback';

import Payments from './views/payments/Payments';
import ManageCarts from './views/manageCarts/ManageCarts';
import LandingPages from './views/landingPages/LandingPages';
import ManagePayments from './views/managePayments/ManagePayments';
import AccountManagement from './views/accountManagement/AccountManagement';
import CourseEnrollments from './views/courseEnrollments/CourseEnrollments';
import MatchCheckPayments from './views/matchCheckPayments/MatchCheckPayments';
import MatchCheckPaymentsDetail from './views/matchCheckPayments/MatchCheckPaymentsDetail';
import ManageVendors from './views/manageVendors/ManageVendors';
import ManageVendorsDetail from './views/manageVendors/ManageVendorsDetail';
import ManageVendorsUserGroups from './views/manageVendors/ManageVendorsUserGroups';
import ManageVendorsUserGroupsAdd from './views/manageVendors/ManageVendorsUserGroupsAdd';

const AppRoutes = () => {
  const { navRoutes, isReadyToRoute } = useNavRoutes();

  if (isReadyToRoute !== true) {
    return <LoadingModal />;
  }

  return (
    <ErrorBoundary fallback={<ErrorBoundaryFallback />}>
      <Routes>
        <Route path="/" element={<Fragment><Outlet /></Fragment>}>
          <Route path={navRoutes.HUB_LANDING_PAGES?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes.HUB_LANDING_PAGES}
                editElement={<LandingPages />} />
            }
          />
          <Route path={navRoutes.PAYMENTS_ROOT?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes.PAYMENTS_ROOT}
                editElement={<Payments />} />
            }
          />
          <Route path={navRoutes.COURSE_ENROLLMENTS_ROOT?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes.COURSE_ENROLLMENTS_ROOT}
                editElement={<CourseEnrollments />} />
            }
          />
          <Route path={navRoutes.ACCOUNT_MANAGEMENT_ROOT?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes.ACCOUNT_MANAGEMENT_ROOT}
                editElement={<AccountManagement />} />
            }
          />
          <Route path={navRoutes.MANAGE_PAYMENTS?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes.MANAGE_PAYMENTS}
                editElement={<ManagePayments />} />
            }
          />
          <Route path={navRoutes.MANAGE_SHOPPING_CART?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes.MANAGE_SHOPPING_CART}
                editElement={<ManageCarts />} />
            }
          />
          <Route path={navRoutes.MATCH_CHECK_PAYMENTS?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes.MATCH_CHECK_PAYMENTS}
                editElement={<MatchCheckPayments />} />
            }
          />
          <Route path={navRoutes.MATCH_CHECK_PAYMENTS_DETAIL?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes.MATCH_CHECK_PAYMENTS_DETAIL}
                editElement={<MatchCheckPaymentsDetail />} />
            }
          />
          <Route path={navRoutes.MANAGE_VENDORS?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes.MANAGE_VENDORS}
                editElement={<ManageVendors />} />
            }
          />
          <Route path={navRoutes.MANAGE_VENDORS_USER_GROUP?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes.MANAGE_VENDORS_USER_GROUP}
                editElement={<ManageVendorsUserGroups />} />
            }
          />
          <Route path={navRoutes.MANAGE_VENDORS_DETAIL?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes.MANAGE_VENDORS_DETAIL}
                editElement={<ManageVendorsDetail />} />
            }
          />
          <Route path={navRoutes.MANAGE_VENDORS_USER_GROUP_ADD?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes.MANAGE_VENDORS_USER_GROUP_ADD}
                editElement={<ManageVendorsUserGroupsAdd />} />
            }
          />

          <Route path="500" element={<UnexpectedError />} />
          <Route path="/*" element={<PageNotFound />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
};

export default AppRoutes;